import { defineComponent as _defineComponent } from 'vue'
import {
    apiGetOrganisationIntegrations,
    apiSaveOrganisationIntegration,
    apiDeleteOrganisationIntegration,
  } from '@/api/integrations';
  import { useStore } from '@/store';
  import { useToasted } from '@/helpers';
  import {
    IntegrationTypes,
    OrganisationIntegration,
    TenantIntegrationSettings,
  } from '@/types/api/integrations';
  import { computed, onMounted, ref } from 'vue';
  import BaseText from '@ui/atoms/baseText/BaseText.vue';
  import DeleteConfirmationModal from '@/components/common/BaseModal/BaseDeleteConfirmModal.vue';

  
  const __default__ = {
    name: 'OrganisationIntegrations',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

  const toasted = useToasted();
  const store = useStore();

  const integrations = ref<Array<OrganisationIntegration>>([]);
  const isDeleting = ref(false);
  const showDeleteConfirmation = ref(false);

  const tenantsIntegrationConfig = computed<TenantIntegrationSettings>(() => {
    const tenantIntegration = integrations.value.find(
      (int) => int.type === IntegrationTypes.TenantIntegration,
    );
    return tenantIntegration?.settings ?? ({ owner: undefined } as TenantIntegrationSettings);
  });
  const organisation = computed(() => {
    return store.state.organisation.organisation;
  });

  onMounted(() => {
    fetchOrganisationIntegrations();
  });

  async function fetchOrganisationIntegrations() {
    const orgId = organisation.value.organisation_id;
    try {
      integrations.value = await apiGetOrganisationIntegrations(orgId);
    } catch (err) {
      toasted.global.general_error({
        message: 'Unable to get organisation integrations',
      });
    }
  }

  async function saveTenantIntegration() {
    try {
      await apiSaveOrganisationIntegration(
        IntegrationTypes.TenantIntegration,
        organisation.value.organisation_id,
        tenantsIntegrationConfig.value,
      );
      await fetchOrganisationIntegrations();
      toasted.global.general_success({
        message: 'Integration saved successfully',
      });
    } catch (err) {
      toasted.global.general_error({
        message: 'Unable to save organisation integration',
      });
    }
  }

  async function deleteTenantIntegration() {
    try {
      isDeleting.value = true;
      await apiDeleteOrganisationIntegration(
        IntegrationTypes.TenantIntegration,
        organisation.value.organisation_id,
      );
      await fetchOrganisationIntegrations();
      toasted.global.general_success({
        message: 'Integration deleted successfully',
      });
      showDeleteConfirmation.value = false;
    } catch (err) {
      toasted.global.general_error({
        message: 'Unable to delete organisation integration',
      });
    } finally {
      isDeleting.value = false;
    }
  }

return { __sfc: true,toasted, store, integrations, isDeleting, showDeleteConfirmation, tenantsIntegrationConfig, organisation, fetchOrganisationIntegrations, saveTenantIntegration, deleteTenantIntegration, BaseText, DeleteConfirmationModal }
}

})